export enum ProcessDetailsTab {
  FILES = 'FILES',
  MESSAGES = 'MESSAGES',
  MULTI_OFFERS = 'MULTI_OFFERS',
  TASKS = 'TASKS',
}
